import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import env from "../env-local";
import HandlerApp from "../utils/handlerApp";

export const useFetch = () => {
    const instance = axios.create({
        baseURL: env.urlBackend,
        headers: {
            Authorization: localStorage.getItem("token") || ""
        }
    });

    const handlerApp = HandlerApp();
    const nav = useNavigate();

    const handleSessionExpired = async (message = "Su sesión ha caducado") => {
        localStorage.clear();

        await Swal.fire({
            title: "",
            text: message,
            icon: "info",
            confirmButtonText: "OK"
        });

        nav("/authenticate");
        return {
            success: false,
            action: "closeSession",
            message
        };
    };

    const notPermissions = () => {
        Swal.fire({
            title: "",
            text: "Not permission",
            icon: "warning"
        });
        handlerApp.setLoader(false);
        nav("/");
    };

    const post = async (url, body = {}, params = "") => {
        params = new URLSearchParams(params).toString();
        url = params !== "" ? url + "?" + params : url;

        return new Promise((resolve, reject) => {
            instance.defaults.timeout = 480000;
            instance.post(url, body)
                .then(async (response) => {
                    if (response.data.success) {
                        resolve(response.data);
                    } else if (response.data.action === "closeSession") {
                        resolve(await handleSessionExpired(response.data.message));
                    } else if (response.data.code === "0001") {
                        notPermissions();
                    } else {
                        resolve(response.data);
                    }
                })
                .catch(async (error) => {
                    if (error.response?.status === 401) {
                        resolve(await handleSessionExpired(error.response.data?.message));
                    } else {
                        reject(error.response?.data || error);
                    }
                });
        });
    };

    const put = async (url, body = {}, params = "") => {
        params = new URLSearchParams(params).toString();
        url = params !== "" ? url + "?" + params : url;

        return new Promise((resolve, reject) => {
            instance.defaults.timeout = 480000;
            instance.put(url, body)
                .then(async (response) => {
                    if (response.data.success) {
                        resolve(response.data);
                    } else if (response.data.action === "closeSession") {
                        resolve(await handleSessionExpired(response.data.message));
                    } else if (response.data.code === "0001") {
                        notPermissions();
                    } else {
                        resolve(response.data);
                    }
                })
                .catch(async (error) => {
                    if (error.response?.status === 401) {
                        resolve(await handleSessionExpired(error.response.data?.message));
                    } else {
                        reject(error.response?.data || error);
                    }
                });
        });
    };

    const get = async (url, params) => {
        params = new URLSearchParams(params).toString();
        url = params !== "" ? url + "?" + params : url;

        return new Promise((resolve, reject) => {
            instance.defaults.timeout = 480000;
            instance.get(url)
                .then(async (response) => {
                    if (response.data.success) {
                        resolve(response.data);
                    } else if (response.data.action === "closeSession") {
                        resolve(await handleSessionExpired(response.data.message));
                    } else if (response.data.code === "0001") {
                        notPermissions();
                    } else {
                        resolve(response.data);
                    }
                })
                .catch(async (error) => {
                    if (error.response?.status === 401) {
                        resolve(await handleSessionExpired(error.response.data?.message));
                    } else {
                        reject(error.response?.data || error);
                    }
                });
        });
    };

    const deleteMethod = async (url, body = {}, params = "") => {
        params = new URLSearchParams(params).toString();
        url = params !== "" ? url + "?" + params : url;

        return new Promise((resolve, reject) => {
            instance.defaults.timeout = 480000;
            instance.delete(url, { data: body })
                .then(async (response) => {
                    if (response.data.success) {
                        resolve(response.data);
                    } else if (response.data.action === "closeSession") {
                        resolve(await handleSessionExpired(response.data.message));
                    } else if (response.data.code === "0001") {
                        notPermissions();
                    } else {
                        resolve(response.data);
                    }
                })
                .catch(async (error) => {
                    if (error.response?.status === 401) {
                        resolve(await handleSessionExpired(error.response.data?.message));
                    } else {
                        reject(error.response?.data || error);
                    }
                });
        });
    };

    return { post, put, get, deleteMethod, nav };
};